// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  background: #F8FAFC;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #0F172A;
  background: #F8FAFC;
}

.font-heading {
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
}

.font-body {
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Hide scrollbar aesthetics */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-track {
  background: #F1F5F9;
}
::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 8px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}

/* Reveal animations */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-up {
  animation: fadeUp 0.7s ease-out both;
}

.fade-up-delay-1 { animation-delay: 0.1s; }
.fade-up-delay-2 { animation-delay: 0.2s; }
.fade-up-delay-3 { animation-delay: 0.3s; }
.fade-up-delay-4 { animation-delay: 0.4s; }

/* Grid pattern for hero */
.bg-grid {
  background-image:
    linear-gradient(to right, rgba(15, 23, 42, 0.04) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(15, 23, 42, 0.04) 1px, transparent 1px);
  background-size: 48px 48px;
}

.bg-dots {
  background-image: radial-gradient(rgba(15, 23, 42, 0.08) 1px, transparent 1px);
  background-size: 20px 20px;
}

/* Text selection */
::selection {
  background: #22A34A;
  color: #FFFFFF;
}

/* Focus rings */
button:focus-visible,
a:focus-visible {
  outline: 2px solid #22A34A;
  outline-offset: 3px;
  border-radius: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iFAAiF;EACjF,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,qEAAqE;AACvE;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB,qBAAqB,EAAE;AAC1C,mBAAmB,qBAAqB,EAAE;AAC1C,mBAAmB,qBAAqB,EAAE;AAC1C,mBAAmB,qBAAqB,EAAE;;AAE1C,0BAA0B;AAC1B;EACE;;2EAEyE;EACzE,0BAA0B;AAC5B;;AAEA;EACE,8EAA8E;EAC9E,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".App {\n  min-height: 100vh;\n  background: #F8FAFC;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: #0F172A;\n  background: #F8FAFC;\n}\n\n.font-heading {\n  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n.font-body {\n  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Hide scrollbar aesthetics */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n::-webkit-scrollbar-track {\n  background: #F1F5F9;\n}\n::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 8px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #94A3B8;\n}\n\n/* Reveal animations */\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-up {\n  animation: fadeUp 0.7s ease-out both;\n}\n\n.fade-up-delay-1 { animation-delay: 0.1s; }\n.fade-up-delay-2 { animation-delay: 0.2s; }\n.fade-up-delay-3 { animation-delay: 0.3s; }\n.fade-up-delay-4 { animation-delay: 0.4s; }\n\n/* Grid pattern for hero */\n.bg-grid {\n  background-image:\n    linear-gradient(to right, rgba(15, 23, 42, 0.04) 1px, transparent 1px),\n    linear-gradient(to bottom, rgba(15, 23, 42, 0.04) 1px, transparent 1px);\n  background-size: 48px 48px;\n}\n\n.bg-dots {\n  background-image: radial-gradient(rgba(15, 23, 42, 0.08) 1px, transparent 1px);\n  background-size: 20px 20px;\n}\n\n/* Text selection */\n::selection {\n  background: #22A34A;\n  color: #FFFFFF;\n}\n\n/* Focus rings */\nbutton:focus-visible,\na:focus-visible {\n  outline: 2px solid #22A34A;\n  outline-offset: 3px;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
